import React from "react";
import SelectedDueDate from "./selectedDueDate";
import SelectDueDatePage from "./selectDueDatePage";
import {
  getUUID,
  getBankDisplayName,
  isSelectedField,
  getAccount,
  isSameBankAccount,
  splitRouting
} from "../../utils/cl_apply_utility";
import { INAVLID_MESSAGES } from "../../constants";
class MakePaymentsFrom extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showDiv: false,
      selectValue: "Select account",
      dropdownSelectedLoan: false,
      makeLoanAccount: {},
      isStateChanged: false,
      isRoutingNumberError: null,
      isInvalidRouting: false
    };
    this.handleSelectBtn2Click = this.handleSelectBtn2Click.bind(this);
    this.updateDropdown = this.updateDropdown.bind(this);
  }
  componentWillMount() {
    let acc ={ ...this.props.offerPreFilled.loanBankInfo.repaymentAccountDetails };
    const newAccount = this.props.externalAccountDetails;
    if(isSelectedField(acc, 'nickname', 'accountNumber')){
      this.state.makeLoanAccount =acc;
      this.state.selectValue = getBankDisplayName(this.state.makeLoanAccount.nickname, this.state.makeLoanAccount.accountNumber);
      this.state.dropdownSelected = true;
    }
    if(newAccount && newAccount.length >= 1){
      let acc=getAccount(newAccount, "REPAYMENT");
      if(acc){
        this.state.makeLoanAccount =acc;
        this.state.selectValue = getBankDisplayName(this.state.makeLoanAccount.nickname, this.state.makeLoanAccount.accountNumber);
        this.state.dropdownSelected = true;
      }
    }
  }
  handleSelectBtn2Click = () => {
    this.setState({ dropdownSelectedLoan: !this.state.dropdownSelectedLoan });
  }
  updateDropdown(e, index) {
    let accDetails = this.props.externalAccountDetails[index];
    
    let isStateChanged={};
    if(!isSameBankAccount(accDetails, this.state.makeLoanAccount)){
      isStateChanged={ isStateChanged: true, isRoutingNumberError: null, isInvalidRouting: false };
    }
    this.setState({ selectValue: e, makeLoanAccount: accDetails, ...isStateChanged });
  }
  resetState=()=>{
    this.setState({ isStateChanged: false }, this.props.resetState);
  }
  errorHandle =(isError, routingNumberNotification)=>{
    let isRoutingNumberError = splitRouting(routingNumberNotification, "REPAYMENT");
    this.props.errorHandle(isError, routingNumberNotification);
    this.setState({
      isRoutingNumberError: isRoutingNumberError,
      isInvalidRouting: isRoutingNumberError?true:false
    });
  }
    render = () => {
      const { showDiv } = this.state;
      const { paymentDueDate } = this.props;
      const isInvalidRoutingNumber = this.state.isInvalidRouting;
      const isInValidAccount = isInvalidRoutingNumber?this.state.isRoutingNumberError.acc:null;
      const isInValidRN = isInvalidRoutingNumber?this.state.isRoutingNumberError.routing:null;
      const errorMessage =INAVLID_MESSAGES.ACCOUNT.ACC_INVALID;
      const colorClass = isInvalidRoutingNumber ?"color-red":"standard-blue";
      const template =(<div key="add-bank-key-5650011" className="standard-blue padding-10-date select-dropdown-margin-left" tabIndex="0" onKeyDown={e=>{ if(this.state.showDiv) { let key = e.keyCode;let min = 0;let max = dropdownBody.childElementCount;if (key === 38) { currentIndex > min ? currentIndex-- : null; } else if (key === 40) { currentIndex < max ? currentIndex++ : null; }let childNodes = dropdownBody && dropdownBody.children;childNodes[currentIndex].focus(accountNumbers);if(key === 13 || key === 32) { this.props.switchTab("REPAYMENT"); } } }}> <a className="standard-blue text-underline" data-track="custom-links" onClick={()=>this.props.switchTab("REPAYMENT")}> Add bank account </a></div>);
      const accountNumbers = this.props.externalAccountDetails.map((ac, index) =>{
        let invalidAccColor = (isInvalidRoutingNumber && (isInValidAccount === ac.accountNumber && isInValidRN === ac.routingNumber))?"color-red":"standard-blue";
        let key = getUUID();
        let dispKey =getBankDisplayName(ac.nickname, ac.accountNumber);
        return (<div key={`${key}-${index}`} className={`padding-10-date select-dropdown-margin-left ${invalidAccColor}`}
          onClick={() => { this.setState({ showDiv: !showDiv });this.updateDropdown(dispKey, index); }}
          tabIndex="0"
          onKeyDown={e=>{
            if(this.state.showDiv) {
              let key = e.keyCode;
              let min = 0;
              let max = dropdownBody.childElementCount;
              if (key === 38) {
                currentIndex > min ? currentIndex-- : null;
              } else if (key === 40) {
                currentIndex < max ? currentIndex++ : null;
              }
              let childNodes = dropdownBody && dropdownBody.children;
              childNodes[currentIndex].focus(accountNumbers);
              if(key === 13 || key === 32) {
                this.setState({ showDiv: !showDiv });
                this.updateDropdown(dispKey, index);
              }
            }
          }} role="option">{dispKey}</div>);
      });
      accountNumbers.push(template);
      let dropdownBody = document.getElementById("makePaymentFromBody");
      let currentIndex = 0;
      return (

        <div>
          <div className="your-loan-details margin-bottom-10 margin-t-25" id="makePayment">Make loan payments from</div>
          <div className="loan-details">
            <div className={`loan-details-section ${isInvalidRoutingNumber?"color-border-red":""}`}
              onKeyDown={e=>{
                let key=e.keyCode;
                key===13?this.setState({ showDiv: !this.state.showDiv }):null;
                key===32?this.setState({ showDiv: true }):null;
                key===27?this.setState({ showDiv: false }):null;
                if((key===38||key===40||key==13||key===32)&&!this.state.showDiv){
                  this.setState({ showDiv: true }, ()=>{
                    this.setState({ showDiv: true });
                  });
                } else if((key===38||key===40||key==13||key===32)&&this.state.showDiv){
                  let childNodes = dropdownBody && dropdownBody.children;
                  childNodes && childNodes[0].focus(accountNumbers);
                }
              }} tabIndex="0" aria-labelledby="makePayment" role="combobox" aria-controls="makePaymentFromBody" aria-expanded={showDiv}>
              <div className={`padding-10-date select-dropdown-margin-left ${isInvalidRoutingNumber?"arrow-condition color-red":"standard-blue"}`}
                value={this.state.selectValue} onClick={() => { this.setState({ showDiv: !showDiv }); this.handleSelectBtn2Click; }}
              >{this.state.selectValue}
                <div className={this.state.showDiv? 'arrow-down' : 'arrow'} />
              </div>
            </div>
          </div>
          { showDiv && (

            <div className="loan-details margin-t-10">
              <div className="loan-details-section padding-top-bottom-10" id="makePaymentFromBody" role="listbox" aria-labelledby="makePayment">
                { accountNumbers }
              </div>
            </div>
          )}
          {isInvalidRoutingNumber?
            <p className="color-red" role="alert"><b>Error:</b> {errorMessage}</p>
            :null
          }
          {/*<p className="margin-t-25"><a className="standard-blue text-underline"*/}
          {/*  onClick={this.props.switchTab}> Add bank account </a></p>*/}
          <SelectDueDatePage paymentDueDate={paymentDueDate} />
          <SelectedDueDate {...this.props} dropdownSelectedLoan={this.state.selectValue}
            dropdownSelected={ this.props.dropdownSelected}
            depositAcc={this.props.depositAcc}
            makeAcc={this.state.makeLoanAccount}
            errorHandle={this.errorHandle}
            isStateChanged={this.state.isStateChanged || this.props.isStateChanged}
            resetState={this.resetState}
            handleRepeatPaymentSelection={this.props.handleRepeatPaymentSelection}/>
        </div>

      );
    }
}

export default MakePaymentsFrom;
